const trimObjectStringProps = (object) => {
  Object.keys(object).forEach((key) => {
    object[key] = typeof object[key] === 'string' ? object[key].trim() : object[key];
  });
  return object;
};


export default trimObjectStringProps;
